import { Navigate, useLocation } from 'react-router-dom'

/**
 * `/cdp` cũ (trang Phân khúc & CDP đã tách): link / dấu trang cũ vẫn mở đúng chỗ mới.
 *   ?tab=segments (mặc định) → /customers/segments (giữ `?tao=1`…)
 *   ?tab=properties | data (view mặc định) → Cài đặt → Thuộc tính khách hàng
 *   ?tab=events | data&view=events → Cài đặt → Sự kiện khách hàng
 *   ?tab=lifecycle → Cài đặt → Pipeline khách hàng (đã gộp mục Vòng đời khách hàng)
 */
export function cdpRedirectTarget(search: string): string {
  const q = new URLSearchParams(search)
  const tab = q.get('tab')
  const view = q.get('view')
  if (tab === 'lifecycle') return '/settings?m=customer-stages'
  if (tab === 'events' || (tab === 'data' && view === 'events')) return '/settings?m=customer-events'
  if (tab === 'properties' || tab === 'data') return '/settings?m=customer-properties'
  q.delete('tab')
  q.delete('view')
  const rest = q.toString()
  return `/customers/segments${rest ? `?${rest}` : ''}`
}

export function CdpRedirect() {
  const { search } = useLocation()
  return <Navigate to={cdpRedirectTarget(search)} replace />
}
